import React, { useContext } from "react";
import stateContext from "../Context/State/StateContext";

const HobiesCom9 = () => {
  const a = useContext(stateContext);

  return (
    <div className="ProfileName m-5 h-full rounded-lg w-[90%]  shadow-xl py-7">
      <div className="center m-5 ">
        <input
          onChange={a.inputValue}
          name="Hobies1"
          value={a.newState.Hobies1}
          className="EditProfile my-7 mb-2 placeholder:text-[#9c50f6] text-[#9c50f6] outline-none border-b border-[#9c50f6] py-2 px-1 w-full font-semibold "
          type="text"
          placeholder="Swimming"
        />
        <input
          onChange={a.inputValue}
          name="Hobies2"
          value={a.newState.Hobies2}
          className="EditProfile my-4 mb-2 placeholder:text-[#9c50f6] text-[#9c50f6] outline-none border-b border-[#9c50f6] py-2 px-1 w-full font-semibold "
          type="text"
          placeholder="Play Criket"
        />
        <input
          onChange={a.inputValue}
          name="Hobies3"
          value={a.newState.Hobies3}
          className="EditProfile my-4 mb-2 placeholder:text-[#9c50f6] text-[#9c50f6] outline-none border-b border-[#9c50f6] py-2 px-1 w-full font-semibold "
          type="text"
          placeholder="Martial Arts"
        />
      </div>
      <div className="btn flex justify-center items-center p-2">
        <button
          onClick={() => {
            a.updateState("");
          }}
          className="discardbtn text-[#9c50f6] font-semibold "
        >
          Discard
        </button>
      </div>
    </div>
  );
};

export default HobiesCom9;
